import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20aesthetic%20abstract%20background%20with%20soft%20golden%20and%20cream%20tones%2C%20flowing%20silk%20texture%2C%20minimalist%20composition%2C%20warm%20atmospheric%20lighting%2C%20subtle%20cherry%20blossom%20petals%2C%20dreamy%20artistic%20photography&width=1600&height=900&seq=anri-hero-bg&orientation=landscape"
        alt="冲田杏梨"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 font-[family-name:var(--font-heading)] tracking-wide">
          冲田杏梨
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-3 max-w-2xl mx-auto">
          Anri Okita · 沖田杏梨
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-xl mx-auto leading-relaxed">
          日本知名写真偶像及演员，本页汇整冲田杏梨的个人资料、出道经历、代表作品、写真集及最新动态，为粉丝提供最全面的一站式信息参考。
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/profile"
            className="px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-user-heart-line mr-2"></i>
            查看个人资料
          </Link>
          <Link
            to="/category/photobooks"
            className="px-6 py-3 rounded-md bg-background-50/20 text-white border border-white/30 font-medium text-sm hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-image-line mr-2"></i>
            浏览写真集
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}